import { z } from "zod"

export const powurOsProposalPriceSchema = z.object({
  id: z.number().int(),
  amount: z.number(),
  startDate: z.string(),
  endDate: z.nullable(z.string()),
  equipmentId: z.number().int(),
})
export type PowurOsProposalPrice = z.infer<typeof powurOsProposalPriceSchema>
